import React from 'react';
import Button from './Button';
import CloseIcon from './CloseIcon';

const CloseButton = ({ onClick }) => (
  <Button variant="light" className="px-[12px] py-[12px]" onClick={onClick} ariaLabel="Close">
    <CloseIcon />
  </Button>
);

export default CloseButton;
